module.exports = __webpack_public_path__ + "static/media/google_login_icon.b7727941.svg";